export default "__VITE_ASSET__Cu5qoVS1__"